<template>

    <div>

        <!--        NAVER        -->
        <naver :email="email"></naver>


    </div>

</template>

<script>

import {TheMask} from 'vue-the-mask'
import Vuex from 'vuex'

import Login from '../modules/login'
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import LottieLoader from '../components/lottie/LottieLoader'
import Markdown from '../components/Markdown'
import Phase from '../components/loginFlow/google/Phase'

import SessionStorage from '../helpers/sessionStorage'


import Naver from '../components/loginFlow/Naver.vue'


export default {

    name: 'login-flow-complex',

    components: {
        Naver,

        LottieLoader,
        Markdown,
        Phase,
        TheMask
    },

    watch: {
        inputValue(value) {
            if (value.length === this.providerAppPassLength) {
                this.errorCountCharacters = false
            }
            this.errorConnection = false
        },
        stepIndex() {
            this.updatePage()
        }
    },

    computed: {

        ...Vuex.mapGetters(['lang']),

        stepTitle() {
            return this.isLogin
                ? this.$t('connect_to_cleanfox')
                : this.$t(this.step.title)
        },

        ctaTextAppPass() {
            return this.externalLinkImg ? this.$t('global_continue') : this.$t('web_google_code')
        },

        ctaIconDoubleAuth() {
            return this.linkRedirectionRequired ? this.externalLinkImg : '/img/icons/arrow-right-white.svg'
        },

        ctaIconAppPass() {
            return this.linkRedirectionRequired ? this.externalLinkImg : '/img/icons/arrow-right-white.svg'
        },

        externalLinkImg() {
            return this.lang === 'ar-sa' ? '/img/icons/external-link-rotated.svg' : '/img/icons/external-link.svg'
        },

        isLogin() {
            return !!(this.step && this.step.isLogin)
        },
        isNaverLogin() {
            return this.isLogin && this.isNaver
        },
        error() {
            return this.errorCountCharacters || this.errorConnection
        },
        errorMessage() {
            return this.errorCountCharacters ? this.$t('google_flow_error') : this.$t('login_error_invalid_email_password')
        },
        step() {
            return this.steps[this.stepIndex]
        },
        ctaNextName() {
            const text = this.linkRedirectionRequired ? this.step.ctaBeforeLink : this.step.ctaNext
            return this.$t(text)
        },
        linePending() {
            return `width: ${((this.stepIndex) / (this.steps.length - 1)) * 100}%;`
        },
        showRedLine() {
            return !this.isDesktop
        },
        isNaver() {
            return this.provider === 'naver'
        },
        providerAppPassLength() {
            return this.isNaver ? 12 : 16
        }

    },

    data() {
        return {
            stepIndex: 0,
            steps: [],
            inputEmail: '',
            inputValue: '',
            errorConnection: false,
            errorCountCharacters: false,
            loading: false,
            email: '',
            provider: '',
            linkRedirectionRequired: false
        }
    },

    created() {
        this.email = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        this.provider = this.$route.path.split('/')[2]
        if (!this.email || !this.provider) {
            this.$router.push({path: '/login/email'})
        }
    },

    mounted() {
        this.updatePage()
    },

    methods: {

        ctaActionLogin() {
            if (this.inputValue.length === this.providerAppPassLength && !this.loading) {
                this.errorConnection = false
                this.errorCountCharacters = false
                this.loading = true
                Tag.clickAll(this, 'web_connexion_flow_gmail_application_password', this.provider)
                Login.connect({
                    vue: this,
                    email: this.email,
                    password: this.inputValue,
                    provider: this.provider
                })
                    .catch(() => {
                        this.errorConnection = true
                        this.loading = false
                    })
            } else {
                this.errorCountCharacters = true
                // Keep the loading state unchanged (user using Enter key)
                // this.loading = false
            }
        },

        goLanding() {
            this.$router.push({path: '/'})
        },

        clickTab(tabIndex) {
            this.clickStepEvent()
            if (tabIndex < this.stepIndex) {
                this.linkRedirectionRequired = false
                this.stepIndex = tabIndex
            }
        },

        clickStepEvent() {
            if (this.step.eventNextStep) {
                Tag.clickAll(this, this.step.eventNextStep, this.provider)
            }
        },

        updatePage() {
            UserFlow.setPage(this, `web_connexion_flow_step${this.stepIndex + 1}`)
            this.linkRedirectionRequired = !!(this.step && this.step.needLinkRedirection)
        },

        ctaPrevious() {
            if (this.stepIndex > 0) {
                this.stepIndex--
            } else {
                this.routerPush('/')
            }
        },

        ctaNext() {
            if (this.linkRedirectionRequired) {
                window.open(this.step.linkTo, '_blank', 'noopener,noreferrer')
                this.linkRedirectionRequired = false
                if (this.step.eventClickLink) {
                    Tag.clickAll(this, this.step.eventClickLink, this.provider)
                }
            } else {
                this.clickStepEvent()
                this.stepIndex++
            }
        },

        actionForceNext() {
            this.stepIndex++
        }

    }
}
</script>

<style lang="scss" scoped>


.lfg {
    display: flex;
    flex-direction: column;

    .header {
        padding: 16px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.12);
        backdrop-filter: blur(10px);
        @media screen and (min-width: $above-tablet-length) {
            padding: 24px 32px;
        }

        .side {
            min-width: 24px;

            @media screen and (min-width: $above-tablet-length) {
                flex: 1;
            }

            &:lang(ar-sa) {
                transform: rotate(180deg);
            }

            button {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $white;
                font-size: 17px;
                font-weight: 600;
                line-height: 24px;
                color: $aquamarine;

                &:lang(ar-sa) {
                    flex-direction: row-reverse;
                }

                > img {
                    @media screen and (min-width: $above-tablet-length) {
                        margin-right: 4px;
                    }
                }
            }
        }

        .title-header {
            flex: 1;
            display: flex;
            justify-content: center;
            cursor: pointer;


            .logo {
                height: 16px;
                @media screen and (min-width: $above-tablet-length) {
                    height: 24px;
                }
            }
        }
    }

    .background {
        flex: 1;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            background-color: #E0F1FC;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .bloc {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 100%;
            @media screen and (min-width: $above-tablet-length) {
                background-color: $white;
                max-width: 720px;
                border-radius: 32px;
                overflow: hidden;
                flex: initial;
            }

            .steps {
                padding: 16px;

                @media screen and (min-width: $above-tablet-length) {
                    padding: 0
                }

                .red-line {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    position: relative;

                    .skypiea {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;


                        .isle {
                            display: flex;
                            flex-direction: column;
                            align-items: center;

                            .circle {
                                width: 24px;
                                object-fit: contain;
                                z-index: 1;
                            }

                            .active {
                                font-weight: 600;
                            }

                            .validated {
                                color: $forest;
                            }
                        }
                    }

                    .alabasta {
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                        padding: 10px 30px 0;

                        .alubarna {
                            position: absolute;
                            height: 2px;
                            margin-left: 36px;
                            margin-right: 36px;
                            left: 0;
                            right: 0;

                            .nanohana {
                                position: relative;
                                height: 2px;

                                .line {
                                    width: 100%;
                                    height: 2px;
                                    background-color: $neutralsPlatinum;
                                    position: absolute;

                                }

                                .line-pending {
                                    //full compatibility
                                    background: rgb(94, 167, 116);
                                    background: -moz-linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                                    background: -webkit-linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                                    background: linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5ea774", endColorstr="#32a3eb", GradientType=1);
                                }

                                .line-completed {
                                    background-color: $forest;
                                    width: 100%;
                                }
                            }
                        }
                    }
                }

                .step-name {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 5px;
                    color: $neutralsMoon;
                    font-size: 15px;
                    font-weight: 400;
                }

                .tabs {
                    display: flex;
                    flex-direction: row;
                    font-size: 17px;
                    font-weight: 400;
                    line-height: 24px;
                    color: $neutralsMoon;


                    .tab {
                        padding: 16px;
                        flex: 1;
                        background-color: $timberwolf;
                        display: flex;
                        align-items: center;

                        > img {
                            width: 20px;
                            object-fit: contain;
                            margin-right: 12px;

                            &:lang(ar-sa) {
                                margin: 0 0 0 12px;
                            }
                        }

                        > span {
                            flex: 1;
                        }
                    }

                    .tab-pending {
                        color: $charcoal;
                        font-weight: 500;
                        background-color: $white;
                    }

                    .tab-completed {
                        color: $forest;
                        background-color: $white;
                        text-align: start;
                        cursor: pointer;
                    }

                    .next-tab {
                        text-align: center;
                        border-bottom-left-radius: 24px;

                        &:lang(ar-sa) {
                            border-bottom-right-radius: 24px;
                            border-bottom-left-radius: 0;
                        }
                    }
                }

            }

        }
    }

    .content {
        flex: 1;
        margin-top: 45px;
        padding: 0 16px 100px;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            padding: 0 80px;
        }

        .article {
            text-align: start;
        }

        .title {
            text-align: start;
            color: $charcoal;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 8px;
        }

        .naver-login {
            display: flex;
            flex-direction: column;
            flex: 1;
            align-items: center;
            justify-content: center;

            .naver {
                height: 24px;
                margin: 48px 0;
            }

            .cta-naver-login {
                margin-top: 40px;
                width: 100%;
            }

            .cta-naver-apppass {
                margin-top: 16px;
                color: $aquamarine;
                text-align: center;
                font-size: 17px;
                font-weight: 600;
                line-height: 24px;
                background-color: $white;
            }
        }
    }
}


.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 16px;
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.12);
    background-color: $white;

    @media screen and (min-width: $above-tablet-length) {
        position: relative;
        padding: 24px 80px 32px;
        box-shadow: none;
    }

    .multiple {
        display: flex;
        flex-direction: row;
        align-items: center;

        .spacer {
            width: 8px;
        }
    }

    button {
        font-family: $font-primary;
        padding: 16px;
        background: $midnight;
        color: $white;
        border-radius: 32px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 17px;
        font-weight: 600;
        line-height: 24px;

        img {
            margin-left: 8px;

            &:lang(ar-sa) {
                margin-left: 0;
                margin-right: 8px;
                transform: rotate(180deg);
            }
        }

        &.back-white {
            background-color: $white;
            border: 4px solid $neutralsPlatinum;
            padding: 12px;
            color: $charcoal;

            & img {
                margin: 0 8px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 8px;
                    transform: rotate(180deg);
                }
            }
        }

    }

    .cta-login {
        background-color: $aquamarine;
    }
}

.subtitle {
    margin-top: 8px;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    text-align: start;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
    }
}

.label {
    width: 100%;
    border-radius: 12px;
    border: 1px solid $neutralsPlatinum;
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    text-align: start;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: $neutralsMoon;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 32px;
        margin-bottom: 16px;
    }

    &.error {
        margin-top: 23px;
        border: 2px solid $raspberry;

        @media screen and (min-width: $above-tablet-length) {
            margin-top: 31px;
        }
    }

    span {
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px
    }

    .input {
        color: $charcoal;
        font-size: 15px;
        font-weight: 400;
        line-height: 20px;
        height: 20px;

        &::placeholder {
            color: $neutralsMoon;
            font-size: 17px;
            font-weight: 400;
            line-height: 24px
        }
    }

    .big-input {
        height: 24px;
    }
}


.label-naver {
    @media screen and (min-width: $above-tablet-length) {
        margin: 0px;
    }
}

.label-naver-password {
    @media screen and (min-width: $above-tablet-length) {
        margin: 8px 0 0;
    }
}


.little-label {
    padding: 18px 16px;
}

.error-message {
    margin-top: 8px;
    color: $white;
    background-color: $raspberry;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    padding: 4px 8px;
    width: fit-content;
    border-radius: 20px;
}

.naver-error-container {
    width: 100%;
    display: flex;
}

</style>
